module.exports = __webpack_public_path__ + "img/Ciencia y Tecnología.6b022d94.svg";